// extracted by mini-css-extract-plugin
export var root = "Text-module--root--18auO";